"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _LineChart = _interopRequireDefault(require("@/components/Charts/LineChart"));
var _DoughnutChart = _interopRequireDefault(require("@/components/Charts/DoughnutChart.vue"));
var chartConfig = _interopRequireWildcard(require("@/components/Charts/chart.config.js"));
var _vuex = require("vuex");
var _moment = _interopRequireDefault(require("moment"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var now = new Date();
var _default = {
  name: 'DashboardDetailsService',
  bodyClass: 'dashboard-details-service-page',
  components: {
    TableServicesActivesCallsList: _components.TableServicesActivesCallsList,
    TableServicesInactivesCallsList: _components.TableServicesInactivesCallsList,
    LineChart: _LineChart.default,
    DoughnutChart: _DoughnutChart.default
  },
  data: function data() {
    return {
      dates: [now, now],
      details: {},
      list: [],
      servicesName: '',
      chartData: {},
      chartRequestsTotal: null,
      chartRequestsCompare: null,
      chartRequestsMonetizablesTotal: null,
      chartRequestsErrorTotal: null,
      listRequestsTotalsxlistRequestM: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        interaction: {
          mode: 'nearest',
          axis: 'x',
          intersect: false
        },
        scales: {
          y: {
            display: true,
            title: {
              display: true
            }
          },
          x: {
            display: true
          }
        },
        plugins: {
          legend: {
            display: false
          }
        }
      },
      optionsDays: [{
        value: 1,
        name: '24 horas'
      }, {
        value: 7,
        name: '7 dias'
      }]
    };
  },
  computed: {
    filterItems: function filterItems() {
      return {
        StartDate: (0, _moment.default)(this.dates[0]).format('YYYY-MM-DD'),
        EndDate: (0, _moment.default)(this.dates[1]).add(1, 'days').format('YYYY-MM-DD')
      };
    },
    titleMonitoramento: function titleMonitoramento() {
      var dateInit = (0, _moment.default)(this.dates[0]);
      var dateEnd = (0, _moment.default)(this.dates[1]);
      var diff = dateInit.diff(dateEnd, 'days');
      if (diff === 0) return 'Monitoramento dos serviços por hora';
      return 'Monitoramento dos serviços por dia';
    }
  },
  mounted: function mounted() {
    this.updateDataItems();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchDetailServiceDashboard', 'fetchLatestServiceCallDashboard', 'fetchLatestServiceCallChartDashboard', 'fetchLatestServiceCallTotalDashboard', 'fetchLatestServiceCallTotalMonetizablesDashboard', 'fetchLatestServiceCallTotalErrorsDashboard'])), {}, {
    updateDataItems: function () {
      var _updateDataItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getDetails();
            case 2:
              this.getDetailsList();
              this.fillChartData();
              this.getRequestsTotals();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function updateDataItems() {
        return _updateDataItems.apply(this, arguments);
      }
      return updateDataItems;
    }(),
    getDetails: function () {
      var _getDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.fetchDetailServiceDashboard(this.filterItems);
            case 2:
              data = _context2.sent;
              if (data) {
                this.details = data;
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getDetails() {
        return _getDetails.apply(this, arguments);
      }
      return getDetails;
    }(),
    getDetailsList: function () {
      var _getDetailsList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this = this;
        var data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.fetchLatestServiceCallDashboard(this.filterItems);
            case 2:
              data = _context3.sent;
              if (data) {
                data.map(function (item) {
                  _this.servicesName += "".concat(item.nm_det_ipa, ", ");
                });
                this.list = data;
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getDetailsList() {
        return _getDetailsList.apply(this, arguments);
      }
      return getDetailsList;
    }(),
    fillChartData: function () {
      var _fillChartData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var data, labels, datasets;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.fetchLatestServiceCallChartDashboard(this.filterItems);
            case 2:
              data = _context6.sent;
              if (!data) {
                _context6.next = 12;
                break;
              }
              labels = [];
              datasets = [];
              if (!(data.labels && data.labels.length)) {
                _context6.next = 11;
                break;
              }
              _context6.next = 9;
              return Promise.all(data.labels.map( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(i) {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!labels.includes(i.hour)) {
                          labels.push(i.hour);
                        }
                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 9:
              _context6.next = 11;
              return Promise.all(data.dataAssets.map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(itemAssets) {
                  var values, item;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!itemAssets.service) {
                          _context5.next = 6;
                          break;
                        }
                        values = [];
                        _context5.next = 4;
                        return Promise.all(itemAssets.times.map(function (j) {
                          values.push(j.totalRequests);
                        }));
                      case 4:
                        item = chartConfig.datasetObjectItem(values, itemAssets.service);
                        datasets.push(item);
                      case 6:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }()));
            case 11:
              this.chartData = {
                labels: labels,
                datasets: datasets
              };
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function fillChartData() {
        return _fillChartData.apply(this, arguments);
      }
      return fillChartData;
    }(),
    getRequestsTotals: function () {
      var _getRequestsTotals = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this2 = this;
        var data, values, labels, colors;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.fetchLatestServiceCallTotalDashboard(this.filterItems);
            case 2:
              data = _context7.sent;
              if (data) {
                values = [];
                labels = [];
                colors = [];
                if (data && data.length) {
                  this.listRequestsTotalsxlistRequestM = [];
                  data.map(function (i) {
                    labels.push(i.service);
                    values.push(i.totalRequests);
                    colors.push(chartConfig.getRandomColor());
                    var item = {
                      label: i.service.toUpperCase(),
                      total: i.totalRequests,
                      billing: 0
                    };
                    _this2.listRequestsTotalsxlistRequestM.push(item);
                  });
                }
                this.chartRequestsTotal = {
                  labels: labels,
                  datasets: [{
                    backgroundColor: colors,
                    data: values
                  }]
                };
                // call others methods
                this.getRequestsTotalsMonetizables();
                this.getRequestsTotalsErrors();
              }
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getRequestsTotals() {
        return _getRequestsTotals.apply(this, arguments);
      }
      return getRequestsTotals;
    }(),
    getRequestsTotalsMonetizables: function () {
      var _getRequestsTotalsMonetizables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this3 = this;
        var data, values, labels, colors;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.fetchLatestServiceCallTotalMonetizablesDashboard(this.filterItems);
            case 2:
              data = _context8.sent;
              if (data) {
                values = [];
                labels = [];
                colors = [];
                if (data && data.length) {
                  data.map(function (i) {
                    labels.push(i.service);
                    values.push(i.totalRequests);
                    colors.push(chartConfig.getRandomColor());
                    _this3.listRequestsTotalsxlistRequestM = _this3.listRequestsTotalsxlistRequestM.map(function (b) {
                      if (b.label === i.service.toUpperCase()) {
                        var item = {
                          label: b.label,
                          total: b.total,
                          billing: i.totalRequests
                        };
                        return item;
                      }
                      return b;
                    });
                  });
                }
                this.chartRequestsMonetizablesTotal = {
                  labels: labels,
                  datasets: [{
                    backgroundColor: colors,
                    data: values
                  }]
                };
                this.generateCompare();
              }
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getRequestsTotalsMonetizables() {
        return _getRequestsTotalsMonetizables.apply(this, arguments);
      }
      return getRequestsTotalsMonetizables;
    }(),
    getRequestsTotalsErrors: function () {
      var _getRequestsTotalsErrors = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this4 = this;
        var data, values, labels, colors;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.fetchLatestServiceCallTotalErrorsDashboard(this.filterItems);
            case 2:
              data = _context9.sent;
              if (data) {
                values = [];
                labels = [];
                colors = [];
                if (data && data.length) {
                  data.map(function (i) {
                    labels.push(i.service);
                    values.push(i.totalRequests);
                    colors.push(chartConfig.getRandomColor());
                    _this4.listRequestsTotalsxlistRequestM = _this4.listRequestsTotalsxlistRequestM.map(function (b) {
                      if (b.label === i.service.toUpperCase()) {
                        var item = {
                          label: b.label,
                          total: b.total,
                          billing: i.totalRequests
                        };
                        return item;
                      }
                      return b;
                    });
                  });
                }
                this.chartRequestsErrorTotal = {
                  labels: labels,
                  datasets: [{
                    backgroundColor: colors,
                    data: values
                  }]
                };
                this.generateCompare();
              }
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getRequestsTotalsErrors() {
        return _getRequestsTotalsErrors.apply(this, arguments);
      }
      return getRequestsTotalsErrors;
    }(),
    generateCompare: function () {
      var _generateCompare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var labels, totals, billings, erros, errosList, list, datasets;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              labels = [];
              totals = [];
              billings = [];
              erros = [];
              errosList = this.details.listNotFetchs;
              this.listRequestsTotalsxlistRequestM.map(function (i) {
                labels.push(i.label);
                totals.push(i.total);
                billings.push(i.billing);
                var verifyError = errosList.find(function (e) {
                  return e.service.toUpperCase() === i.label.toUpperCase();
                });
                if (verifyError) {
                  erros.push(verifyError.totalErrors);
                } else {
                  erros.push(0);
                }
              });
              list = ['Total', 'Sucesso', 'Erros'];
              datasets = [];
              list.map(function (i) {
                var values = null;
                var color = chartConfig.getRandomColor();
                var colorBack = chartConfig.transparentize(color);
                if (i === 'Total') values = totals;
                if (i === 'Sucesso') values = billings;
                if (i === 'Erros') {
                  values = erros;
                  color = 'rgb(255 0 0)';
                  colorBack = chartConfig.transparentize(color);
                }
                var item = _objectSpread(_objectSpread({}, chartConfig.datasetObjectItem(values, i, color)), {}, {
                  backgroundColor: colorBack
                });
                datasets.push(item);
              });
              if (datasets.length) {
                this.chartRequestsCompare = {
                  labels: labels,
                  datasets: datasets
                };
              }
            case 10:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function generateCompare() {
        return _generateCompare.apply(this, arguments);
      }
      return generateCompare;
    }(),
    goBack: function goBack() {
      this.$router.back();
    }
  })
};
exports.default = _default;